import { Link } from "@tanstack/react-router";
import type { ComponentProps } from "react";
import { getRoute } from "./route-registry";
import type {
	DynamicRouteKey,
	RouteParams,
	StaticRouteKey,
} from "./route-types";

type BaseTypedLinkProps = Omit<
	ComponentProps<typeof Link>,
	"to" | "href" | "params"
>;

type StaticTypedLinkProps = {
	[K in StaticRouteKey]: BaseTypedLinkProps & { route: K };
}[StaticRouteKey];

type DynamicTypedLinkProps = {
	[K in DynamicRouteKey]: BaseTypedLinkProps & {
		route: K;
		params: RouteParams[K];
	};
}[DynamicRouteKey];

type TypedLinkProps = StaticTypedLinkProps | DynamicTypedLinkProps;

/**
 * Type-safe Link component
 */
export function TypedLink(props: TypedLinkProps) {
	if ("params" in props) {
		const { route, params, ...linkProps } = props;
		return <Link to={getRoute(route, params)} {...linkProps} />;
	}

	const { route, ...linkProps } = props;
	return <Link to={getRoute(route)} {...linkProps} />;
}
